import * as React from 'react';
import { USER_ROLES } from '@/constants/user-roles';
import { Layout as DashboardLayout } from '@/layouts/v2/layout';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import { paths } from '@/paths';
import Invitation from '@/pages/v2/invitation';
import { RoleGuard } from '@/components/auth/guards/role-guard';
import { GuestGuard } from '@/components/auth/guards/guest-guard';

export const route: RouteObject = {
  path: paths.invitation.token(':token'),
  element: <GuestGuard><Outlet /></GuestGuard>,
  children: [
    {
      index: true,
      element: <Invitation />,
    },
  ],
};
